import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { environment } from 'src/environments/environment';
import { Company } from 'src/app/domains/companies/models';
import { TrialKitRequest } from 'src/app/domains/trial-kit/models';
import { TrialKitService } from 'src/app/domains/trial-kit/services';
import { AddressService } from 'src/app/shared/services/address/address.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-company-trial-kit',
  templateUrl: './company-trial-kit.component.html',
  styleUrls: ['./company-trial-kit.component.scss']
})
export class CompanyTrialKitComponent implements OnInit {
  @Input() company: Company;
  public form: UntypedFormGroup;
  private emailPattern = /^\w+([\.-]?\w+)+@\w+([\.:-]?\w+)+(\.[a-zA-Z0-9]{2,})+$/;
  public googleKey = environment.googlePlacesApiKey;
  public trialKits: Array<any> =
  [
    {
      id: 'None',
      name: 'company.trial-kit.none.name'
    },
    {
      id: 'Smart',
      name: 'company.trial-kit.smart.name'
    },
    {
      id: 'Air',
      name: 'company.trial-kit.air.name'
    },
    {
      id: 'Mix',
      name: 'company.trial-kit.mix.name'
    }
  ];
  public selectedKit: any;
  public loading: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private addressService: AddressService,
    private trialKitService: TrialKitService,
    private notificationService: NotificationService,
    private translateService: TranslateService
    ) { }

  ngOnInit() {
    this.form = this.fb.group({
      firstName: [null, [Validators.required]],
      lastName: [null, Validators.required],
      email: [null, [Validators.required, Validators.pattern(this.emailPattern)]],
      companyName: [null, [Validators.required]],
      address: [null, [Validators.required]]
    });
    this.selectedKit = this.trialKits[1];
  }

  validField(name: string) {
    const control = this.form.get(name);
    return (control.invalid && !control.pristine) || (control.invalid && control.touched)
  }

  getErrorEmail() {
    const control = this.form.get('email');
    if(control.errors && control.errors.pattern) {
      return 'company.trial-kit.form.email.error-pattern';
    } else {
      return 'company.trial-kit.form.email.error';
    }
  }

  onSelectKit(kit: string) {
    this.selectedKit = kit;
  }

  onSubmit() {
    if(this.form.valid) {
      const value = this.form.value;
      let trialKitReq: TrialKitRequest = {
        first_name: value.firstName,
        last_name: value.lastName,
        email: value.email,
        package: this.selectedKit.id,
        company: value.companyName,
        shipping_address: this.addressService.getAddressLine(value.address),
        shipping_city: this.addressService.getCity(value.address),
        shipping_state: this.addressService.getCountry(value.address),
        shipping_zip: this.addressService.getZip(value.address)
      }
      this.loading = true;
      this.trialKitService.requestTrialKit(trialKitReq).subscribe((res: any) => {
        this.loading = false;
        this.notificationService.success(
          this.translateService.instant(
          'company.trial-kit.success',
          {name: this.selectedKit.id}
          )
        );
      }, () => {
        this.loading = false;
      });
    }
  }

}
